import React from 'react'
import { CGE } from "../../../../common/components/CGE";
import { urlParams, decode_utf8, getPathName, getCurrentTime, changeCurrancyFormat } from "../../../../common/utils/utilsFunc";
import { LiferayService } from "../../../../common/services/liferay/index";
import PaymentOnlineContextProvider, {
    PaymentOnlineContext,
    ACTIONS
  } from "../../context/PaymentOnlineContextProvider";
import Loading from "../../../../common/components/Loading";

function ProofPayment({ props }) {
    const [state, dispatch] = React.useContext(PaymentOnlineContext);
    const [dataClient, setDataClient] = React.useState();
    const [detailClient, setDetailClient] = React.useState();
    const [statusPayment, setStatusPayment] = React.useState();
    const [loading, setLoading] = React.useState(true);
    const [confirmedToggle, setConfirmedToggle] = React.useState(false);
    const [messagePayment, setMessagePayment] = React.useState();
    const fintocPollingRef = React.useRef(null);

    const FINTOC_PROVIDER = "fintoc";
    const FINTOC_POLLING_INTERVAL = Number(props.fintoc_comprobante_polling_interval || 5000);
    const FINTOC_MAX_ATTEMPTS = Number(props.fintoc_comprobante_max_attempts || 12);
    const fintocStatusEndpoint = props.fintoc_comprobante_status_endpoint || "fintoc/payment-status";

    function sendEmail(prop) {
        setLoading(true);
        let json = {
            "contentName": props.titlle_correo_webContent_comprobante_de_pago,
            "direccion": `${detailClient?.COMUNA},  ${detailClient?.NUMERO_CASA ? detailClient?.NUMERO_CASA : ""} - ${detailClient?.CALLE ? detailClient?.CALLE : ""}`,
            "emailTitular": dataClient?.Meta?.Header?.Email,
            "empresa": props.codigo_empresa,
            "estadoPago": dataClient?.State,
            "fecha": dataClient?.ConfirmedAt,
            "monto": dataClient?.Amount,
            "ncliente": dataClient?.CtaCto,
            "ncomprobante": dataClient?.BuyOrder,
            "servicio": props.servicio_description_comprobante_de_pago
        }
        if(prop === "send"){
            dispatch({
                type: ACTIONS.SET_JSON_SEND_EMAIL,
                payload: json
            })
        } else {
            dispatch({
                type: ACTIONS.SET_JSON_DOWNLOAD_COMPROV,
                payload: json
            })
        }
    }

    function isFintocReturn() {
        const provider = (urlParams.get("provider") || urlParams.get("paymentProvider") || "").toLowerCase();
        return provider === FINTOC_PROVIDER || !!urlParams.get("transaction") || !!urlParams.get("internalTransactionId");
    }

    function getFintocTransactionId() {
        return urlParams.get("transaction") || urlParams.get("internalTransactionId") || urlParams.get("PaymentID");
    }

    function normalizeFintocStatus(trace) {
        const estadoSap = (trace?.estadoSAP || trace?.estadoSap || "").toUpperCase();
        const estadoFintoc = (trace?.estadoFintoc || "").toUpperCase();

        if (estadoSap === "EXITOSO" || estadoSap === "OK" || estadoSap === "SAP_OK") {
            return "success";
        }

        if (estadoSap === "ERROR" || estadoSap === "SAP_ERROR") {
            return "error";
        }

        if (estadoFintoc === "FAILED" || estadoFintoc === "CANCELLED" || estadoFintoc === "CANCELED" || estadoFintoc === "EXPIRED") {
            return "error";
        }

        return "pending";
    }

    function buildFintocProof(trace) {
        const status = normalizeFintocStatus(trace);
        const paymentReference = trace?.idReferenciaFintoc || trace?.idPaymentIntent || trace?.idTransaccionInterna;
        const paymentDate = trace?.timestampTransaccionFintoc || trace?.timestampUltimaNotificacionSap || trace?.dateModified || trace?.dateCreated;
        const paymentState = status === "success" ? "PAGO CONFIRMADO" : status === "error" ? "ERROR" : "PENDIENTE";

        return {
            Amount: trace?.monto,
            BuyOrder: paymentReference,
            Confirmed: status === "success",
            ConfirmedAt: paymentDate,
            CtaCto: trace?.cuentaContrato,
            State: paymentState,
            Meta: {
                Header: {
                    Email: trace?.correoCliente
                }
            },
            rawTrace: trace
        };
    }

    async function consultFintocTrace(transactionId, attempt = 1) {
        if (!transactionId || transactionId === "undefined") {
            setLoading(false);
            setStatusPayment("error");
            setMessagePayment(props.error_comprobante_de_pago || "No fue posible obtener la transacción Fintoc.");
            return;
        }

        try {
            const response = await LiferayService.getFintocPaymentStatus(
                props.base_url_api,
                fintocStatusEndpoint,
                transactionId
            );

            if (response?.code && response.code !== 0) {
                throw new Error(response?.message || "Error consultando trazabilidad Fintoc");
            }

            const trace = response?.data || response?.trace || response;
            const status = normalizeFintocStatus(trace);
            const proof = buildFintocProof(trace);

            setStatusPayment(status);
            setDataClient(proof);

            if (trace?.cuentaContrato) {
                dispatch({
                    payload: trace.cuentaContrato,
                    type: ACTIONS.SET_IDCTACTO,
                });
            }

            if (status === "success") {
                setConfirmedToggle(true);
                setLoading(false);
                return;
            }

            if (status === "error") {
                setConfirmedToggle(false);
                setLoading(false);
                setMessagePayment(trace?.mensajeError || props.error_comprobante_de_pago || "No fue posible confirmar el pago.");
                return;
            }

            setConfirmedToggle(false);
            setLoading(false);
            setMessagePayment(props.fintoc_comprobante_pending_message || "Estamos validando tu pago. Esto puede tardar unos minutos.");

            if (attempt < FINTOC_MAX_ATTEMPTS) {
                fintocPollingRef.current = setTimeout(() => consultFintocTrace(transactionId, attempt + 1), FINTOC_POLLING_INTERVAL);
            }
        } catch (error) {
            if (attempt < FINTOC_MAX_ATTEMPTS) {
                setStatusPayment("pending");
                setLoading(false);
                setMessagePayment(props.fintoc_comprobante_pending_message || "Estamos validando tu pago. Esto puede tardar unos minutos.");
                fintocPollingRef.current = setTimeout(() => consultFintocTrace(transactionId, attempt + 1), FINTOC_POLLING_INTERVAL);
                return;
            }

            setStatusPayment("error");
            setConfirmedToggle(false);
            setLoading(false);
            setMessagePayment(props.error_comprobante_de_pago || "No fue posible consultar el estado del pago.");
        }
    }

    React.useEffect(() => {
        if(getPathName().includes('comprobante-de-pago')){
            if (isFintocReturn()) {
                const transactionId = getFintocTransactionId();
                setLoading(true);
                setStatusPayment("pending");
                setMessagePayment(props.fintoc_comprobante_pending_message || "Estamos validando tu pago. Esto puede tardar unos minutos.");
                consultFintocTrace(transactionId);
                return;
            }

            const paymentIDParam = urlParams.get("PaymentID");
            if (paymentIDParam && paymentIDParam !== "undefined") {
                setLoading(true);
                dispatch({
                    type: ACTIONS.SET_ID_PAYMENT,
                    payload: paymentIDParam
                })
            } else {
                setLoading(false);
                const paymentStatus = urlParams.get("status");
                setStatusPayment(paymentStatus);
                dispatch({
                    type: ACTIONS.SET_ID_PAYMENT,
                    payload: ''
                })
            }
        }

        return () => {
            if (fintocPollingRef.current) {
                clearTimeout(fintocPollingRef.current);
            }
        };
    }, [getPathName()]);

    React.useEffect(() => {
        if(state.responseProofPaid){
            setStatusPayment(state?.responseProofPaid?.State);

            if(state.responseProofPaid?.CtaCto){
                setDataClient(state.responseProofPaid)
                dispatch({
                    payload: state.responseProofPaid?.CtaCto,
                    type: ACTIONS.SET_IDCTACTO,
                });
                if(state.responseProofPaid.Confirmed){
                    setConfirmedToggle(true);
                }else{
                    setLoading(false);
                    setConfirmedToggle(false)
                }
            } else{
                setLoading(false);
                props.setGlobalAlert(decode_utf8(props.text_fetch_error),"warning", true, "Advertencia");
            }
        }
    }, [state.responseProofPaid])

    React.useEffect(() => {
        if(state.responseSendEmail){
            if(state.responseSendEmail?.out === "OK"){
                props.setGlobalAlert( decode_utf8("Correo electrónico enviado con éxito"),"success", true, "Confirmación");
            } else {
                props.setGlobalAlert(decode_utf8(props.text_fetch_error),"warning", true, "Advertencia");
            }

             setLoading(false);
        }
    }, [state.responseSendEmail])

    React.useEffect(() => {
        if(state.responseDownloadComp){
            if(state.responseDownloadComp.code === 0) {
                let mywindow = window.open('', 'PRINT', 'height=650,width=900,top=100,left=150');
                mywindow.document.write(`<html><head><title>Comprobante_de_pago${getCurrentTime()}</title>`);
                mywindow.document.write(state.responseDownloadComp?.message);
                mywindow.focus();
                setTimeout(() => {
                    mywindow.print();
                    mywindow.close();
                    mywindow.document.close();
                }, 100);
            } else {
                props.setGlobalAlert(state.responseDownloadComp?.message ? state.responseDownloadComp?.message : decode_utf8(props.text_fetch_error),"warning", true, "Advertencia");
            }

            setLoading(false);
        }
    }, [state.responseDownloadComp])

    React.useEffect(() => {
        if(state.detailClient){
          if(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN || state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
            if(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0){
                setDetailClient(state.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM)
                dispatch({
                    payload: '',
                    type: ACTIONS.SET_RESPONSE_PROOF_PAID,
                });
            } else {
                setDetailClient([])
                props.setGlobalAlert(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN ? state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN : decode_utf8(props.text_fetch_error) ,"warning", true, "Advertencia");
            }
          } else {
            setDetailClient([])
            props.setGlobalAlert(decode_utf8(props.text_fetch_error),"warning", true, "Advertencia");
          }

          setLoading(false);
        }
    }, [state.detailClient])

    var panelActionsTop =
        confirmedToggle && <div className="d-flex justify-content-between">
            <CGE.Button
                label="Guardar"
                onClick={() => sendEmail()}
                className="mb-4"
                size="sm"
            />
        </div>

    var panelActionsFooter =
        statusPayment !== "error" && <div className="cge-proof-payment-footer">
            <div className="row">
                <div className="col-md-12 px-0 text-center">
                    <CGE.Text size="8" text="Deseas enviar comprobante por correo electrónico?"/>
                    <CGE.Spacing type="sm" />
                    <CGE.Button
                        label="Enviar"
                        onClick={() => sendEmail('send')}
                        className="mb-4 mx-auto"
                        size="sm"
                    />
                </div>
            </div>
        </div>

    return (
        <CGE.Panel title={decode_utf8(props.titulo_comprobante_de_pago)} topContent={panelActionsTop} >
            {(statusPayment !== "error" && statusPayment !== "pending") && confirmedToggle ?
            <CGE.PanelSectionTicket title={ decode_utf8(props.titulo_comprobante_de_pago)}>
                {detailClient?.CTA_CTO && <div className="text-center">
                    <CGE.Text size="7" text={`N° Cliente : ${detailClient?.CTA_CTO} | ${detailClient?.COMUNA ? detailClient?.COMUNA : ""}, ${detailClient?.CALLE ? detailClient?.CALLE : ""} ${detailClient?.NUMERO_CASA ? detailClient?.NUMERO_CASA : ""} ${detailClient?.SUPLEMENTO ? detailClient?.SUPLEMENTO : ""} ${detailClient?.PISO ? detailClient?.PISO : ""}`} style={{ color: 'black'}} />
                    <CGE.Spacing type="nl" />
                </div>}
                <div className="row border-bottom pb-2 ">
                <div className="col-md-6">
                    <CGE.Text size="7" text={"Servicio:"} style={{ color: 'black' }} />
                </div>
                <div className="col-md-6">
                    <CGE.Text size="7" text={props.servicio_description_comprobante_de_pago} style={{ color: 'black' }} />
                </div>
                </div>
                <CGE.Spacing type="sm" />
                <div className="row border-bottom pb-2 ">
                <div className="col-md-6">
                    <CGE.Text size="7" text={"Fecha de Comprobante:"} style={{ color: 'black' }} />
                </div>
                <div className="col-md-6">
                    <CGE.Text size="7" text={dataClient?.ConfirmedAt} style={{ color: 'black' }} />
                </div>
                </div>
                <CGE.Spacing type="sm" />
                <div className="row border-bottom pb-2 ">
                    <div className="col-md-6">
                        <CGE.Text size="7" text={"N° de Comprobante:"} style={{ color: 'black' }} />
                    </div>
                    <div className="col-md-6">
                        <CGE.Text size="7" text={dataClient?.BuyOrder} style={{ color: 'black' }} />
                    </div>
                </div>
                <CGE.Spacing type="sm" />
                <div className="row border-bottom pb-2 ">
                    <div className="col-md-6">
                        <CGE.Text size="7" text={"Monto:"} style={{ color: 'black' }} />
                    </div>
                    <div className="col-md-6">
                        <CGE.Text size="7" text={changeCurrancyFormat(dataClient?.Amount)} style={{ color: 'black' }} />
                    </div>
                </div>
                <CGE.Spacing type="sm" />
                <div className="row border-bottom pb-2 ">
                    <div className="col-md-6">
                        <CGE.Text size="7" text={  "Estado Pago:" } style={{ color: 'black' }} />
                    </div>
                    <div className="col-md-6">
                        <CGE.Text size="7" text={ dataClient?.State} style={{ color: 'black' }} />
                    </div>
                </div>
                <CGE.Spacing type="nl" />
                <CGE.Text size="8" text={decode_utf8(props.observacion_comprobante_de_pago)} />
                <CGE.Spacing type="nl" />
            </CGE.PanelSectionTicket> :
            <CGE.PanelContainer
             className="p-4"
             alingItensCenter={true}
             size="sm"
            >
             { !loading && <>
                <div className="cge-altaSubscriptionConfirmation__icon text-center mb-3">
                <CGE.Icon style={{ fontSize: '45px', color: `${statusPayment === 'pending' ? '#ffd90b' : '#f32735'}` }} name="attention" />
                 </div>
                <CGE.Heading
                    className="font-weight-normal text-justify"
                    size="4"
                    text={statusPayment === "error" ? (messagePayment || props.error_comprobante_de_pago) : statusPayment === "pending" ? (messagePayment || 'El estado está pendiente. En espera de confirmación, espere unos minutos.') : `${dataClient?.BuyOrder?`El pago no fue realizado. Transacción N° ${dataClient?.BuyOrder}`:"El pago no fue realizado."}`}
                />
             </>
                }
         </CGE.PanelContainer>
            }
            {loading && <Loading />}
            {confirmedToggle && panelActionsFooter}
        </CGE.Panel>
    )
}

const ProofPaymentWithProvider = ({props}) => (
    <PaymentOnlineContextProvider>
      <ProofPayment props={props} />
    </PaymentOnlineContextProvider>
  );
export default ProofPaymentWithProvider;
